const {jQuery: $} = window;
import Utils from "./utils.class";
import InPageNav from "./inPageNav.class";
import TabsLayout from "./layouts/tabs";
import PeopleGrid from "./layouts/people_grid";
import Featherlight from "./../lib/featherlight";
import Marketo from "./Marketo.class";
import Trustarc from "./Trustarc.class";
import Cookies from 'js-cookie';
import ZoomInfo from "./ZoomInfo.class";
import Neverbounce from "./Neverbounce.class";

export default class Theme {
    $main;
    $html;
    $body;
    $header;
    #builder;
    #inPageNav;
    #config;
    #scrollOffset;
    scrollSpeed;
    #TabsLayout;
    #RotatingTabs;
    #PeopleGrid;
    #Neverbounce;
    #tabbedNav;
    #nav;
    #ZoomInfo;
    #slider;
    #marketo;
    #trustarc;
    #utils;
    #$admin;
    #root;
    #isEditing = false;

    #counter;

    constructor(
        config,
        builder,
        utils,
        slider,
        tabbedNav,
        nav,
    ) {
        this.#config = config;
        this.#builder = builder;
        this.#utils = utils;
        this.#scrollOffset = 0;
        this.#root = document.querySelector(":root");

        this.scrollSpeed = 750;
        this.$html = $('html');

        this.$body = $('body');
        this.$main = $('.site-wrapper');
        this.$header = $('header.site_header');
        this.#$admin = $('#wpadminbar');

        if (window.location.hash === "#dev") {
            Cookies.set("debug", "1");
        }

        Utils.log("Theme Config:", config);

        this.#inPageNav = new InPageNav(this);
        this.#TabsLayout = new TabsLayout(this);
        this.#PeopleGrid = new PeopleGrid(this);
        this.#marketo = new Marketo(config.marketoID, window.location.host, config.marketoURL, config.emailBannedDomains, config.emailFreeDomains, config.formAutosetValues);
        this.#trustarc = new Trustarc(this.$body);
        //this.#Neverbounce = new Neverbounce(config.neverBounce.key, config.neverBounce.enabled);
        this.#marketo.registerPlugin("ZoomInfo", new ZoomInfo("Email", config.zoomInfo.formID, config.zoomInfo.globalEnabled && config.zoomInfo.pageEnabled, Cookies.get("debug") === "1", {
            "companyEmployees": (val) => {

                if(val < 500) {
                    return "Below 500";
                } else if(val < 750) {
                    return "501-749";
                } else if(val <= 1500) {
                    return "750-1500 SME";
                } else if(val <= 2500) {
                    return "1501-2500 MidTier";
                } else if(val <= 7500) {
                    return "2501-7500 Enterprise";
                }

                return "7501+ Lrg Enterprise";
            }
        }));

        this.#slider = slider;
        this.#tabbedNav = tabbedNav;
        this.#nav = nav;

        this.#counter = $('.counter__number');

        this.#trustarcIntegration();
        //$(window).trigger(this.#trustarc.events.consent.functional);
    }

    __onReady() {
        const me = this;

        Utils.log("Theme Ready");

        me.#TabsLayout.events();
        me.#PeopleGrid.events();
        me.#slider.setup();
        // me.#tabbedNav.events();
        this.#nav.events();

        $(window).on('hashchange', function (e) {
            Utils.log("Scroll to Section Ready");

            if (location.hash) {
                if (!Utils.scrollToHash(location.hash, null, me.scrollOffset + 100, me.scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $(document).on('click', 'a', function (e) {
            let $el = $(this);

            if ($el.attr('href') && $el.attr('href').search('#') === 0) {
                let hash = $el[0].hash;

                if (!Utils.scrollToHash(hash, null, me.scrollOffset + 100, me.scrollSpeed)) {
                    e.preventDefault();
                }
            }
        });

        $('a').each(function(i, el) {
            var url = $(el).attr("href");
            // use url.indexOf() to look for youtube embed urls
            // apply featherlight on those tags
            if(url) {
                if(url.indexOf("youtube.com/watch?v=") >= 0 || url.indexOf("youtu.be/") >= 0 || (url.indexOf("youtube.com/embed/") >= 0)){
                    var id = Utils.youtubeParser(url);
                    $(el).attr("data-featherlight", "iframe")
                        .attr("data-featherlight-iframe-width", "850")
                        .attr("data-featherlight-iframe-height", "468")
                        .attr("data-featherlight-iframe-frameborder", "0")
                        .attr("data-featherlight-iframe-allow", "autoplay; encrypted-media")
                        .attr("data-featherlight-iframe-allowfullscreen", "true")
                        .attr("href", "https://www.youtube.com/embed/" + id + "?rel=0&amp;autoplay=1" );

                    $(el).featherlight();
                }
            }
        });

        $(".js-author-lightbox").on("click", function (e) {
            const $this = $(this);
            const $parent = $this.parents(".builder-layout");
            const id = $this.data("id");
            const url = `${window.themeSettings.restURL}wp/v2/ppma_author/${id}`;
            let $popup = null;

            e.preventDefault();

            $.ajax(url, {
                method: "GET",
                dataType: "json",
                beforeSend: () => {
                    $popup = $parent.find(".people_grid__popupTemplate").clone().appendTo("body");
                    $popup.removeClass("people_grid__popupTemplate--hidden");
                }
            }).done((data) => {
                Utils.log(data);

                fillOrKill($popup.find(".sp_description__headshot"), `<img src="${data.avatar}" alt="${data.name}, ${data.position}">`);
                fillOrKill($popup.find(".sp_description__name"), data.name);
                fillOrKill($popup.find(".sp_description__caption"), data.position);
                fillOrKill($popup.find(".sp_description__blurb"), data.description);
                fillOrKill($popup.find(".sp_description__linkedin"), data.linkedin, "href");

                $popup.find(".js-popup-loading").hide();
                $popup.find(".sp_description").show();

                $popup.on("click", () => {
                    $popup.remove();
                });

                $popup.find(".sp_description").on("click", (e) => {
                    e.stopPropagation();
                });

                $popup.find(".js-popup-close").on("click", () => {
                    $popup.remove();
                });
            }).fail(() => {
                console.warn("Failed to fetch author data.");
                $popup.remove();
            });

            return false;
        });

        function fillOrKill($el, content, attr = "html") {
            if(content) {
                if(attr === "html") {
                    $el.html(content);
                } else {
                    $el.attr(attr, content);
                }
            } else {
                $el.remove();
            }
        }
    }

    __onLoad() {
        const me = this;

        Utils.log("Theme Load");
        this.#$admin = $('#wpadminbar');

        me.#slider.show();

        Utils.equalHeight('.image_callout__text', '.builder-layout');
        Utils.equalHeight('.graphic_card__text', '.builder-layout');
        Utils.equalHeight('.carouselSpotlight__slide', '.carouselSpotlight');
        Utils.equalHeight('.rollover-height', '.builder-section-type--rollover');

        this.#TabsLayout.init();

        this.$header.addClass('fixed');
        $(window).trigger("resize");

        if (location.hash) {
            Utils.log("Scroll to Section Load");

            setTimeout(function () {
                Utils.scrollToHash(location.hash, null, me.scrollOffset, me.scrollSpeed);

            }, 300);
        }

        setTimeout(function () {
            me.#inPageNav.events();
            $(window).trigger("resize");
        }, 1000);

        Utils.equalHeight('.js-equalizer-logo', '.logo-slider-container');

        function counter(el) {
            let $me = $(el),
                time = ($me.attr('data-time') || 3) * 1000,
                countTo = $me.attr('data-count'),
                delay = ($me.attr('data-delay') || 0) * 1000;

            setTimeout(function () {
                $({
                    countNum: 0
                }).animate({
                        countNum: countTo
                    },

                    {
                        duration: time,
                        easing: 'linear',
                        step: function () {
                            $me.text(Utils.commaSeparateNumber(Math.floor(this.countNum)));
                        },
                        complete: function () {
                            $me.text(Utils.commaSeparateNumber(this.countNum));
                        }
                    }
                );
            }, delay);
        }

        this.#counter.each(function (i, el) {

            $(el).on('animationTrigger', function () {
                counter(el);
            });

            $(el).data('waypoint', new Waypoint.Inview({
                element: el,
                entered: function (dir) {
                    if ($(el).parents('.animation-trigger').length == 0) {
                        counter(el);
                    }
                },
                exited: function (dir) {

                }
            }));
        });

        $('.search-bar .search-button').on('click', function () {
            $(this).parent().toggleClass('open');
        });

        $('.single_accordion .single_accordion__header').on('click', function () {
            const $column = $(this).parent();

            $column.toggleClass('open');
            $column.find('.single_accordion__inner').slideToggle({
                duration: 250,
                progress: function () {
                    $(window).trigger('resize');
                }
            });
        });

        $(window).on("keydown", (e) => {
            if(e.ctrlKey && e.which === 77 && !this.#isEditing && $("#mockup-controls").length > 0) {
                this.EnableMockupMode(true);
            }
        });
    }

    __onResize() {
        this.#updateCssHeaderHeight();
    }

    activatePlayer() {
        // TODO: Implement video platform integration
    }

    #trustarcIntegration() {
        const self = this;

        $(window).on(this.#trustarc.events.consent.functional, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcFunctional(true, event.hasRun);
            event.hasRun = true;
        });

        $(window).on(this.#trustarc.events.consent.advertising, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcAdvertising(true, event.hasRun);
            event.hasRun = true;
        });

        $(window).on(this.#trustarc.events.denied.functional, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcFunctional(false, event.hasRun);
            event.hasRun = true;
        });

        $(window).on(this.#trustarc.events.denied.advertising, function event() {
            event.hasRun = event.hasRun || false;
            self.#trustarcAdvertising(false, event.hasRun);
            event.hasRun = true;
        });
    }

    #trustarcFunctional(consent, hasRun) {

        if (consent) {
            if (!hasRun) {
                // Only run this code once
                if (this.#marketo) {
                    const $mktoForms = $("[id^='mktoForm_']");

                    if ($mktoForms.length > 0 && $mktoForms.parents("#modalPopup").length < $mktoForms.length) {
                        this.#marketo.load();
                    }
                }
            }
        } else {
            // No consent
        }
    }

    #trustarcAdvertising(consent, hasRun) {
        if (consent) {
            if (window.VidyardV4) {
                VidyardV4.api.GDPR.consent(true);
                Utils.log("Vidyard: Have tracking consent.");
            } else {
                Utils.log("Vidyard: API not loaded yet.");
            }
        } else {
            // No consent
            if (window.VidyardV4) {
                VidyardV4.api.GDPR.consent(false);
                Utils.log("Vidyard: No tracking consent.");
            } else {
                Utils.log("Vidyard: API not loaded yet.");
            }
        }
    }

    EnableMockupMode(status) {
        const $page = $("#page");
        const $html = $("html");
        const $body = $("body");

        if(status) {
            if(!$body.hasClass('mockup-edited')){
                $page.data("original", $page.html());
            }
            $page.attr("contenteditable", true);
            $body.addClass("mockup-editing");
            this.#isEditing = true;
        } else {
            $page.attr("contenteditable", false);
            $body.removeClass("mockup-editing").addClass("mockup-edited");
            this.#isEditing = false;

            $.getScript(location.protocol + "//" + location.host + "/wp-content/themes/kmdg/dist/js/mockup.min.js", () => {
                $page.html(HtmlDiff.execute($page.data("original"), $page.html()));

                let changes = "";
                $("*:is(.diffdel, .diffmod, del.mod, ins.mod, .diffins)").not(":empty").each((i, el) => {
                    const id = Math.round(Math.random()*100000);

                    const temp = $(el).clone();
                    let inner = temp.html().trim();

                    if(inner === '') temp.html("(whitespace)");

                    $(el).attr("data-scroll", `el-${id}`)

                    changes += `<li><a href="#el-${id}">${temp[0].outerHTML}</a></li>`;
                });

                $("body").append(`<pre class='mockup-changelog'><ul style="margin:0">${changes}</ul></pre>`);

                const slug = themeSettings.page;
                const id = themeSettings.postID;
                const html = "<!DOCTYPE html>" + $html[0].outerHTML;
                const bl = new Blob([html], {type: "text/html"});
                const a = document.createElement("a");
                a.href = window.URL.createObjectURL(bl);
                a.download = `mockup--${slug}--${id}.html`;
                a.style.display = 'none';
                document.body.appendChild(a);
                a.innerHTML = "Save";
                a.click();
                window.URL.revokeObjectURL(url);
            });
        }
    }

    get utils() {
        return Utils;
    }

    get headerHeight() {
        if (this.#$admin.length > 0) {
            return this.$header.outerHeight() + this.#$admin.outerHeight();
        }

        return this.$header.outerHeight();
    }

    get scrollOffset() {
        let subNav = 0;

        if (this.#inPageNav.isActive) {
            subNav = this.#inPageNav.height;
        }

        return this.#scrollOffset + this.headerHeight + subNav;
    }

    #updateCssHeaderHeight() {
        this.#root.style.setProperty('--header-height', this.headerHeight + "px");
    }
}